//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'AppMenuItem',

    props: {
        active: {
            required: false,
            type: Boolean,
            default: false,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
    },

    methods: {
        handleClick() {
            if (this.disabled) {
                return;
            }

            this.$eventBus.emit('close-app-menu');
            this.$emit('click');
        },
    },
};
